<template>
<div class="container">
    <div class="row">
        <div class="col text-center">
            <img src="https://nscmediacdn.azureedge.net/nsc/calculators/mental-health/mental-health-calculator.png" class="img-fluid" alt="Mental Health Cost Calculator - National Safety Council" />
            <p class="mt-3 mb-5">This calculator codes serious psychological distress within the past year if respondents reported: periods of intense nervousness, hopelessness, restlessness, depression, things requiring great effort, or felt down on themselves. We refer to serious psychological distress as mental distress.</p>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <nav class="calctabs">
                <ul class="nav nav-tabs resultTabs" id="myTabs" role="tablist">
                    <li class="nav-item pt-2"><div class="text-nowrap">Results by State:</div></li>
                    <li v-for="(location, index) in locations"
                        class="nav-item"
                        :id="'tab-'+location.id"
                        role="presentation"
                        :key="location.id">
                        <button :class="index === selectedLocationIndex ? 'active nav-link font-weight-bold' : 'nav-link font-weight-bold'"
                                :aria-controls="'state-'+location.state.Name"
                                role="tab"
                                @click="selectLocation(index)">
                            {{location.state.Name}}
                        </button>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</div>
<div>
<Result :model="selectedLocation"/>
</div>
</template>

<script>
import Result from '@/components/Result';
import store from "@/store";
import _ from 'lodash';

export default {
    components: {
        Result
    },
    name: "ResultsContainer",
    data() {
        return {
            state: store.state,
            selectedLocationIndex: 0
        }
    },
    methods: {
        selectLocation(location) {
            this.selectedLocationIndex = location;
        }
    },
    computed: {
        selectedLocation() {
            return this.locations[this.selectedLocationIndex];
        },
        locations() {
            return _.toArray(this.state.locations);
        }
    },
    setup() {
        if (store.state.industry === null) {
            let queryString = window.location.hash.split('?')[1];
            let urlParams = new URLSearchParams(queryString);
            let industry = urlParams.get('industry');
            let locations = JSON.parse(atob(urlParams.get('locations')));
            store.loadFromURI(industry, locations);
            store.computeResults();
        }
    },
    mounted(){
        window.scrollTo(0, 0);
    }
}
</script>

<style scoped>
  button:focus {
      outline: none;
      box-shadow: none;
  }
</style>